export default "__VITE_ASSET__CZPG9mPq__"